export const SKIP_WELCOME_PARAM = 'blank'

export const COUPON_CODE_PARAM = 'coupon_code'

export const CHECK_AUTH_PARAM = 'check_auth'

export const UTM_SOURCE_PARAM = 'utm_source'

export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'placement',
]

export const SERVICE_PARAMS = [
  SKIP_WELCOME_PARAM,
  COUPON_CODE_PARAM,
  CHECK_AUTH_PARAM,
  ...UTM_KEYS,
]

export const OAUTH_ACCESS_TOKEN_PARAM = 'access_token'
export const OAUTH_STATE_PARAM = 'state'

export const UTM_STORAGE_KEY = 'utm'
export const COUPON_STORAGE_KEY = 'coupon_code'
